import { useCorporatePaymentMethodsQuery } from 'modules/billing/queries/useCorporatePaymentMethodsQuery'
import { EnumOfferType } from 'modules/billing/types/offers'
import { useCorporateLifecycleQueries } from 'modules/corporate/hooks/useCorporateLifecycleQueries'
import { useCorporateOfferQuery } from 'modules/corporate/queries/useCorporateOffer.query'
import { useCallback } from 'react'

import { useAuthenticatedUserQuery } from '../queries/useAuthenticatedUser.query'

export const useRequiredAuthDataQueries = () => {
  const { data: user } = useAuthenticatedUserQuery()

  const {
    data: { isKycComplete, corporate },
    isLoading: isCorporateLifecycleLoading,
    isError: isCorporateLifecycleError,
    errorRefetch: refetchCorporateLifecycle,
  } = useCorporateLifecycleQueries()

  const {
    data: corporateOffer,
    isLoading: isCorporateOfferLoading,
    isError: isCorporateOfferError,
    refetch: refetchCorporateOffer,
  } = useCorporateOfferQuery(user?.corporateId)

  const {
    data: corporatePaymentMethods,
    isLoading: isCorporatePaymentMethodsLoading,
    isError: isCorporatePaymentMethodsError,
    refetch: refetchCorporatePaymentMethods,
  } = useCorporatePaymentMethodsQuery(corporate?.id, {
    enabled:
      !!corporate?.id &&
      corporateOffer?.offerType === EnumOfferType.STRICTLY_MANAGEMENT_TOOLS,
  })

  const errorRefetch = useCallback(() => {
    if (isCorporateLifecycleError) {
      return refetchCorporateLifecycle
    } else if (isCorporateOfferError) {
      return refetchCorporateOffer
    } else if (isCorporatePaymentMethodsError) {
      return refetchCorporatePaymentMethods
    }
  }, [
    isCorporateLifecycleError,
    isCorporateOfferError,
    isCorporatePaymentMethodsError,
    refetchCorporateLifecycle,
    refetchCorporateOffer,
    refetchCorporatePaymentMethods,
  ])

  return {
    data: {
      isKycComplete,
      user,
      corporate,
      corporateOffer,
      corporatePaymentMethods,
    },
    isUserAuthenticated: !!user,
    isFetchLoading:
      isCorporateLifecycleLoading ||
      isCorporateOfferLoading ||
      isCorporatePaymentMethodsLoading,
    isFetchError:
      isCorporateLifecycleError ||
      isCorporateOfferError ||
      isCorporatePaymentMethodsError,
    errorRefetch,
  }
}
